import { ethers } from "ethers";
import keccak256 from "keccak256";
import { MerkleTree } from "merkletreejs";
import abi from "../src/contract/abi.json";
import { getMaxMintAmount } from "./getMaxMint.js";
import { claimlist } from "./inoackwhitelist";
import { useEffect, useState } from "react";
import { Address } from "./whitelist";
import Main from "../src/assets/main.gif";
import Alert from "@mui/material/Alert";
import "./App.css";
import Image from "./Logo.png";

import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function App() {
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState({});
  const getProof = (address) => {
    console.log(Address);
    const leaves = Address.map((v) => keccak256(v));
    //console.log(leaves);
    const tree = new MerkleTree(leaves, keccak256, { sort: true });
    // console.log(tree);
    const leaf = keccak256(address);
    // console.log(leaf);
    const proof = tree.getHexProof("0xb1C98CBEf3CBC328B6BF1cF53EB1e92ce37B5b17");
    return proof;
  };

  const getclaimProof = (address) => {
    console.log(Address);
    const leaves = claimlist.map((v) => keccak256(v));
    //console.log(leaves);
    const tree = new MerkleTree(leaves, keccak256, { sort: true });
    // console.log(tree);
    const leaf = keccak256(address);
    // console.log(leaf);
    const proof = tree.getHexProof(leaf);
    return proof;
  };

  const connectWallet = async () => {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    await provider.send("eth_requestAccounts", []);
    const signer = provider.getSigner();
    const network = await provider.getNetwork();
    const chainId = network.chainId;
    console.log(chainId);
    console.log("CONNECTED");
    if (chainId !== 56) {
      toast.error("Please Switch to bsc Mainnet");
    }
  };

  useEffect(() => {
    connectWallet();
  }, []);

  const write = async () => {
    if (typeof window.ethereum !== "undefined") {
      try {
        setLoading(true);
        const contract_address = "0xDce57f6E1497524C2456a867689fed056924F1B1";
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const accounts = await provider.listAccounts();
        const add = accounts[0];
        const signer = provider.getSigner();
        const proof = getProof(add);
        const options = { value: ethers.utils.parseEther("1.5") };
        const contract = new ethers.Contract(contract_address, abi, signer);
        const addressmint = getMaxMintAmount(add);
        console.log(addressmint);
        const res = await contract.mint(1, proof, options);
        console.log(proof);
        setLoading(false);
        console.log(res);
        if (res.hash !== undefined) {
          toast.success("Successfully Minted");
        }
        setLoading(false);
      } catch (error) {
        if (
          error.message.includes("execution reverted: Invalid merkle proof")
        ) {
          toast.error("Invalid proof");
          return;
        } else if (
          error.message.includes("User denied transaction signature")
        ) {
          toast.error("User denied transaction signature");
          return;
        } else if (
          error.message.includes(
            "insufficient funds for intrinsic transaction cost "
          )
        ) {
          toast.error("Insufficient funds for intrinsic transaction cost");
          return;
        }

        toast.error("The Tx Failed");

        console.log(error);
      }
    }
  };

  useEffect(() => {
    connectWallet();
  }, []);

  const claim = async () => {
    if (typeof window.ethereum !== "undefined") {
      try {
        setLoading(true);
        const contract_address = "0xDce57f6E1497524C2456a867689fed056924F1B1";
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const accounts = await provider.listAccounts();
        const add = accounts[0];
        const signer = provider.getSigner();
        const proof = getclaimProof(add);
        const options = { value: ethers.utils.parseEther("0.99") };
        const contract = new ethers.Contract(contract_address, abi, signer);
        const addressmint = getMaxMintAmount(add);
        console.log(addressmint);
        const res = await contract.claim(addressmint, proof);
        console.log(proof);
        setLoading(false);
        console.log(res);
        if (res.hash !== undefined) {
          toast.success("Successfully Minted");
        }
        setLoading(false);
      } catch (error) {
        if (
          error.message.includes("execution reverted: Invalid merkle proof")
        ) {
          toast.error("Invalid proof");
          return;
        } else if (
          error.message.includes("User denied transaction signature")
        ) {
          toast.error("User denied transaction signature");
          return;
        } else if (
          error.message.includes(
            "insufficient funds for intrinsic transaction cost "
          )
        ) {
          toast.error("Insufficient funds for intrinsic transaction cost");
          return;
        }

        toast.error("The Tx Failed");

        console.log(error);
      }
    }
  };
  return (
    <div className="App">
      <div className="img-container">
        <a href="https://nftacknoledger.com/">
          <img className="logo__image" src={Image} alt=""></img>
        </a>
        <img src={Main} alt="main" className="image" />
        {typeof window.ethereum === undefined ? (
          <Button
            onClick={connectWallet}
            sx={{
              marginTop: "50px",
              width: "100%",
              height: "50px",
              borderRadius: "25px",
              border: "none",
              backgroundColor: "#f1f1f1",
              color: "#000",
              fontSize: "20px",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#000",
                color: "white",
              },
            }}
          >
            Connect Wallet
          </Button>
        ) : (
          <Button
            onClick={write}
            sx={{
              marginTop: "50px",
              width: "100%",
              height: "50px",
              borderRadius: "25px",
              border: "none",
              backgroundColor: "#f1f1f1",
              color: "#000",
              fontSize: "20px",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#000",
                color: "white",
              },
            }}
          >
            {isLoading ? "minting..." : "mint"}
          </Button>
        )}
      </div>
      <ToastContainer />
    </div>
  );
}

export default App;
